import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  initTelemetry,
  TelemetryErrorBoundary,
  ReportProblem,
  setupConsoleTelemetry,
} from '@cca/ui';
import { App } from './App';
// Shared design system: structural + role tokens, then the canonical component
// classes. Imported before the app stylesheet so app-specific rules can still
// layer on top; parishes keeps its own base reset/body (14px) so we take tokens
// + components only, not @cca/ui base.
import '@cca/ui/tokens';
import '@cca/ui/components';
import './styles/global.css';

// Production telemetry (Phase 4): window errors, unhandled rejections, render +
// API failures. Same-origin endpoint (worker is on parishes.*/api).
const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
initTelemetry({ portal: 'parishes', endpoint: `${apiBase}/api/telemetry` });

// Fold console.error / console.warn into the SAME redacted telemetry channel,
// source-minimised (cca-a7q, audit M3). Runs AFTER initTelemetry so the reporter
// is configured. The old raw unredacted console→/api/logs/console forwarder is
// removed.
setupConsoleTelemetry();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <TelemetryErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReportProblem />
    </TelemetryErrorBoundary>
  </StrictMode>,
);
